import { getModelFromSnapshot } from 'lib/model';
import { OrganizationModel } from 'lib/model/objects/organizationModel';
import { ESnapshotExists, EOrganization, ESnapshot, ERate } from 'lib/types';
import { getFirebaseContext } from 'utils/firebase';

export const shouldHidePricePreview = ({
  newspaper,
  rate
}: {
  newspaper?: ESnapshotExists<EOrganization>;
  rate?: ESnapshot<ERate>;
}): boolean => {
  if (rate?.data()?.hidePreview) {
    return true;
  }

  if (newspaper) {
    const publisherOrganizationModel = getModelFromSnapshot(
      OrganizationModel,
      getFirebaseContext(),
      newspaper
    );

    return publisherOrganizationModel.isExpress;
  }

  return false;
};
